import "rxjs";
import { fetchGlossary } from '../api';
import { Observable } from "rxjs/Observable";
import { ABORT_REQUEST_GLOSSARY, REQUEST_GLOSSARY } from "../types";
import { fullfiled, throwError } from '../actions/glossary-actions';

export const glossaryEpic = action$ =>
    action$
        .ofType(REQUEST_GLOSSARY)
        .map(action => action.payload)
        .mergeMap(
        (token) => Observable.fromPromise(fetchGlossary(token)).map(fullfiled)
            .takeUntil(action$.ofType(ABORT_REQUEST_GLOSSARY))
            .catch(e => Observable.of(throwError(e)))
        )


// WEBPACK FOOTER //
// ./src/epics/glossary-epics.js